// Daily Challenge — the same question set for everyone on a given UTC day.
//
// The day's question order is derived deterministically from the date string via
// the existing secret-keyed sequence (see shared/token.ts `sequenceKey`), so it
// needs no storage to be reproducible: two players who start the same day's
// challenge compute the identical order. The `daily_challenges` table just
// persists a record and lets a Scheduled Function pre-create it.
//
// Pure module (no Node APIs) so it is shared by client, server, and tests.
import type { Canon, DifficultyFilter } from "./types";

/** Correct answers needed to finish the Daily Challenge (shorter than a full race). */
export const DAILY_FINISH_LINE = 10;
/** The Daily draws from every category at mixed difficulty. */
export const DAILY_CATEGORIES: string[] = [];
export const DAILY_DIFFICULTY: DifficultyFilter = "mixed";
export const DAILY_CANON: Canon = "protestant-66";

/** UTC calendar day (YYYY-MM-DD) for an epoch-ms instant — groups a daily board
 *  and identifies the challenge. Uses UTC so the day rolls over globally at once. */
export function utcDateString(epochMs: number): string {
  return new Date(epochMs).toISOString().slice(0, 10);
}

/** The deterministic seed for a given day. Everyone who plays that day's
 *  challenge derives the identical question order from it. */
export function dailySeed(date: string): string {
  return `daily:${date}`;
}
